const utilities = {

  getChangeMeta(percentChange: number) {
    return {
      changeText: `${percentChange > 0 ? "+" : ""}${percentChange.toFixed(1)}%`,
      changeType: percentChange >= 0 ? "positive" : "negative",
    };
  },
  
};

export default utilities;